export default "__VITE_ASSET__CIVFHdsL__"